/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var par = require("par");

var INITIAL_RECONNECT_WAIT = 1 * 1000;

module.exports = Model({
	name: "braceletfindevents",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_bracelet: "",
	_initialReconnectTimer: null,

	tellAllReconnect: tellAllReconnect,
	tellFinishReconnect: tellFinishReconnect,
});

function init() {
	this._machines = [];
	this.push({});
}

function uninit() {
	this._machines = null;
}

function triggers() {
	return {
		"find": find,
		"finish": finish,
		"finish:one": finishOne,
	};
}

function listeners() {
	return {
		"connectivity:online": handle_reconnected,
		"availablemachines:updated": handle_available_machine_updated,
	};
}

function find(data) {
	var bracelet = data.bracelet;
	var model = data.model;
	this._bracelet = bracelet;
	this._model = model;

	this._active = true;

	this._initialReconnectTimer = setTimeout(tellAllReconnect.bind(this), INITIAL_RECONNECT_WAIT);
}

function finish() {
	this._active = false;

	clearTimeout(this._initialReconnectTimer);

	this._machines.forEach(par(tellFinishReconnect, this._bracelet), this);
}

function finishOne(data) {
	var machine = data.machine;
	var bracelet = data.bracelet || this._bracelet;
	this.tellFinishReconnect(bracelet, machine);
}

function tellAllReconnect() {
	var machines = this._machines;
	machines.forEach(tellReconnect, this);
}

function tellReconnect(machine) {
	var bracelet = this._bracelet;
	var model = this._model;
	var update = {};
	update[machine] = bracelet;
	this.extend(update);

	this.emit("machineevents:trigger:find", {
		machine: machine,
		bracelet: bracelet,
		model: model
	});
}

function tellFinishReconnect(bracelet, machine) {
	var update = {};
	update[machine] = "";
	this.extend(update);

	this.emit("machineevents:trigger:find:finish", {
		machine: machine,
		bracelet: bracelet
	});
}

function handle_reconnected() {
	if (!this._active) return;

	this.tellAllReconnect();
}

function handle_available_machine_updated(machines) {
	var oldMachines = this._machines;
	this._machines = machines;

	var newMachines = machines.filter(function (machine) {
		return oldMachines.indexOf(machine) === -1;
	});

	if (this._active) {
		newMachines.forEach(tellReconnect, this);
	} else {
		newMachines.forEach(finishIfNotFinished, this);
	}
}

function finishIfNotFinished(machine) {
	var bracelet = this.data[machine];
	if (!bracelet) return;
	this.tellFinishReconnect(bracelet, machine);
}
